/**
 * The design system's public surface. Import from "../components" rather than reaching into
 * individual files, so a component can be split or renamed without touching every screen.
 */

export { Icon, Spinner } from "./Icon";
export type { IconInput, IconTuple } from "./Icon";

export { Button, IconButton } from "./Button";
export type { ButtonProps, ButtonVariant, ButtonSize } from "./Button";

export { Modal, ModalBody, ModalFooter } from "./Modal";
export type { ModalProps, ModalSize } from "./Modal";

export { ConfirmModal } from "./ConfirmModal";
export type { ConfirmModalProps } from "./ConfirmModal";

export { Card, CardHeader, CardBody, CardFooter, PageContainer } from "./Card";
export { PageHeader, SectionHeader } from "./PageHeader";

export { Table, Thead, Tbody, Tr, Th, Td, TdActions } from "./Table";

export { FormGroup, Label, Input, Textarea, Select, Checkbox, Field, FieldError } from "./Form";

export { Badge, CountPill, StatusBadge } from "./Badge";
export type { BadgeTone } from "./Badge";

export { LoadingState, ErrorState, EmptyState, ListStates, Banner } from "./States";
export type { BannerTone, EmptyStateProps } from "./States";

export { DetailSection, DetailField, EmptyDetail, IdBadge } from "./Detail";

export { Toolbar, SearchInput, FilterPill } from "./Toolbar";

export { CrudPage } from "./CrudPage";
export type { CrudResource, CrudColumn, CrudField } from "./CrudPage";
